import { DoughnutChart } from '@sanlam-glacier/app-common/components';
import { clamp } from 'lodash';
import styles from '../exposure-breakdown-takeover.module.scss';
import { Reg28InfrastructureExposureWeightsResponseModelMock } from '../../../../types/regulation-28/regulation-28.interfaces';

type ActualRegionalExposureChartProps = {
  chartData?: Reg28InfrastructureExposureWeightsResponseModelMock;
};

export const Reg28ActualRegionalExposureChart = ({
  chartData
}: ActualRegionalExposureChartProps) => {
  const totalForeign = chartData?.foreign ?? 0;
  const totalLocal = chartData?.local ?? 0;
  const unallocated = clamp(100 - (totalForeign + totalLocal), 0, 100);

  return (
    <div className={styles.regionalExposureChart}>
      <DoughnutChart
        labels={['Local %', 'Foreign %', 'Unallocated']}
        values={[totalLocal, totalForeign, unallocated]}
      />
    </div>
  );
};
